import { render, staticRenderFns } from "./CreateTableItem.vue?vue&type=template&id=6258311f&scoped=true"
import script from "./CreateTableItem.vue?vue&type=script&lang=js"
export * from "./CreateTableItem.vue?vue&type=script&lang=js"
import style0 from "./CreateTableItem.vue?vue&type=style&index=0&id=6258311f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6258311f",
  null
  
)

export default component.exports